import { ForwardedRef, PropsWithChildren } from 'react';
import cn from 'classnames';
import { CardVariant } from '../types';
import styles from './card.module.scss';

export type CardProps = PropsWithChildren & {
  variant?: CardVariant;
  className?: string;
  ref?: ForwardedRef<HTMLDivElement>;
};

export const Card = ({ variant = CardVariant.main, className, children, ref }: CardProps) => {
  return (
    <div ref={ref} className={cn(styles.card, className, styles[`card-${variant}`])}>
      {children}
    </div>
  );
};
